import { useInstance } from '@meraki-internal/react-dependency-injection';
import moment from 'moment';
import { DateTimePicker } from '../../components/picker/DateTimePicker';
import { DurationPicker } from '../../components/picker/DurationPicker';
import { AlertPresenter } from '../../app/AlertBinder';
import { ICommonMissionState } from '../model/ICommonMissionState';
import { DrawerLabel } from '../../components/drawer/DrawerLabel';
import { ITimeChangeSource } from '../model/NewMissionState';
import { PickerWrapper } from '../../components/picker/PickerWrapper';
import { getTimezone } from '../../support/helpers/format';

export const MissionTimesEditor: React.FC<{mission: ICommonMissionState, source: ITimeChangeSource }>  = ({ mission, source }) => {
    const alert = useInstance(AlertPresenter);

    const onChangeStartTime = async (startTime: string) => {
        try {
            await mission.setStartTime(startTime, source);
        } catch (e: any) {
            e.message = `Failed setting mission start time: ${e.message}`;
            alert.showAndLogError(e);
        }
    };

    const onChangeDuration = async (duration: number) => {
        try{
            await mission.setDurationMinutes(duration, source);
        } catch (err: any){
            err.message = `Failed setting mission duration: ${err.message}`;
            alert.showAndLogError(err);
        }
    };

    const fromDate = moment().toISOString();
    const toDate = moment().add(90, 'd').toISOString();
    const timezone = getTimezone(mission.getLocation()!);

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 0}}>
            <div>
                <DrawerLabel text="Date and Time" />
                <PickerWrapper>
                    <DateTimePicker color="primary" fromDate={fromDate} toDate={toDate} minuteIncrement={5} dateTime={mission.getStartTime()} timezone={timezone} onChange={onChangeStartTime} />
                </PickerWrapper>
            </div>
            <div>
                <DrawerLabel text="Duration" />
                <PickerWrapper>
                    <DurationPicker color="primary" durationMinutes={mission.getDurationMinutes()} onChange={onChangeDuration} />
                </PickerWrapper>
            </div>
        </div>
    );
};
